import React from 'react';
import './RefundPolicy.css';

function RefundPolicy() {
  return (
    <div className="page-refundpolicy">
      <div
        style={{
          position: 'absolute',
          width: 0,
          height: 0,
          overflow: 'hidden',
        }}
        aria-hidden="true"
      >
        <>
          <svg
            width="699"
            height="196"
            viewBox="0 0 699 196"
            fill="none"
            id="svg-1137231340_6119"
          >
            <path
              d="M668.903 75.4492C685.462 75.4492 698.806 91.3256 699 111.098C699 111.195 699 111.39 699 111.488C699 111.682 699 111.877 699 111.975C698.806 131.747 685.462 147.623 668.903 147.623C668.027 147.623 667.15 147.623 666.176 147.526L666.079 147.428C659.163 146.649 653.904 140.805 653.904 133.792V129.604H647.865V137.299V147.623V162.501L626.826 177.72V111.488V75.4492H647.865V85.7737V93.4684H653.904V89.2801C653.904 82.2673 659.163 76.3258 666.079 75.5466H666.176C667.15 75.4492 668.027 75.4492 668.903 75.4492ZM662.767 126.585C671.144 126.682 677.962 119.864 677.962 111.488C677.962 103.208 671.144 96.3904 662.767 96.4878C654.683 96.5852 647.962 103.208 647.865 111.39V111.488C647.865 111.585 647.865 111.585 647.865 111.682C647.962 119.864 654.683 126.487 662.767 126.585Z"
              fill="#030319"
            />
            <path
              d="M583.064 75.4492C602.933 75.4492 619.102 91.6177 619.102 111.488C619.102 131.455 602.933 147.623 583.064 147.623C563.096 147.623 546.928 131.455 546.928 111.488C546.928 91.6177 563.096 75.4492 583.064 75.4492ZM583.064 126.585C591.343 126.585 598.063 119.864 598.063 111.488C598.063 103.208 591.343 96.4878 583.064 96.4878C574.687 96.4878 567.966 103.208 567.966 111.488C567.966 119.864 574.687 126.585 583.064 126.585Z"
              fill="#030319"
            />
            <path
              d="M488.334 147.623V60.5712L509.373 45.3523V147.623H488.334ZM518.431 147.623V58.9032L539.47 43.6843V147.623H518.431Z"
              fill="#030319"
            />
            <path
              d="M459.569 85.7737V75.4492H480.608V111.488V147.623H459.569V137.299V129.604H453.53V133.792C453.53 140.805 448.368 146.649 441.355 147.428H441.258C440.381 147.526 439.407 147.623 438.531 147.623C422.07 147.623 408.628 131.747 408.434 111.975C408.434 111.78 408.434 111.682 408.434 111.488C408.434 111.39 408.434 111.195 408.434 111C408.628 91.3255 422.07 75.4492 438.531 75.4492C439.407 75.4492 440.381 75.4492 441.258 75.5466H441.355C448.368 76.3258 453.53 82.2673 453.53 89.2801V93.4684H459.569V85.7737ZM459.569 111.682C459.569 111.585 459.569 111.585 459.569 111.488V111.39C459.472 103.208 452.848 96.5852 444.667 96.4878C436.29 96.3904 429.472 103.208 429.472 111.488C429.472 119.864 436.29 126.585 444.667 126.585C452.848 126.487 459.472 119.767 459.569 111.682Z"
              fill="#030319"
            />
            <path
              d="M365.433 96.4878C357.056 96.4878 350.336 103.208 350.336 111.488C350.336 119.864 357.056 126.585 365.433 126.585C371.569 126.585 376.926 122.883 379.166 117.526H400.984C398.159 134.571 383.257 147.623 365.433 147.623C345.465 147.623 329.297 131.455 329.297 111.488C329.297 91.6177 345.465 75.4492 365.433 75.4492C383.257 75.4492 398.159 88.4035 400.984 105.546H379.166C376.926 100.189 371.569 96.4878 365.433 96.4878Z"
              fill="#030319"
            />
            <path
              d="M281.603 66.6326C266.839 66.6326 260.844 71.4881 260.844 77.8003C260.844 89.745 321.687 81.7819 321.687 115.479C321.687 120.335 315.245 147.623 278.739 147.623C254.492 147.623 244.023 133.833 239.37 127.715L238.744 126.938L254.724 115.283C254.724 115.283 262.365 126.647 278.739 126.647C293.592 126.647 299.587 121.792 299.587 115.479C299.587 103.243 238.744 111.692 238.744 77.8003C238.744 72.9448 245.186 45.6566 281.603 45.6566C305.94 45.6566 316.408 59.4464 321.061 65.5644L321.687 66.3412L305.707 77.6162C305.707 77.6162 298.066 66.6326 281.603 66.6326Z"
              fill="#030319"
            />
            <ellipse
              cx="97.8957"
              cy="97.8954"
              rx="97.8957"
              ry="97.8954"
              fill="url(#svg-1137231340_6119_paint0_linear_1843_2573)"
            />
            <path
              d="M103.576 14.4118C115.249 13.8539 129.142 17.6986 139.282 23.2509C158.722 33.8511 173.055 51.8528 179.03 73.1714C184.904 94.1022 182.275 116.505 171.709 135.505C161.278 154.663 143.583 168.825 122.604 174.805C121.916 175 121.535 175.131 120.923 174.79C120.848 174.232 123.053 171.981 123.588 171.354C127.648 166.588 129.697 162.178 131.673 156.382C133.304 155.423 134.869 154.356 136.358 153.19C151.792 141.054 161.837 123.339 164.329 103.867C166.932 83.664 161.768 65.3031 149.385 49.2548C145.6 44.5826 141.241 40.4056 136.412 36.8219C127.789 30.443 117.883 26.3644 107.081 25.9036C100.34 25.6159 94.1717 26.5885 89.9416 32.5503C88.1358 35.1174 87.0577 38.1249 86.8214 41.2544C85.8581 52.6598 94.7935 61.1826 102.438 68.3351C106.731 72.3277 111.304 76.1609 115.634 80.1021C126.117 89.6427 137.49 100.106 139.627 114.873C140.71 122.355 139.833 129.826 137.214 136.929C136.785 138.093 136.144 140.229 135.444 141.211L135.214 141.233C134.907 140.566 134.342 137.129 134.064 136.042C133.36 133.295 132.371 130.526 131.084 127.972C123.12 112.161 107.759 101.092 95.0915 89.0304C83.0497 77.5651 70.841 66.3252 69.8719 48.4363C69.4109 39.9256 72.4487 31.2566 78.2811 25.0667C85.079 17.8519 93.8037 14.7104 103.576 14.4118Z"
              fill="white"
            />
            <path
              d="M91.5742 180.82C79.901 181.378 66.0082 177.534 55.8688 171.981C36.4285 161.381 22.0955 143.379 16.1206 122.061C10.246 101.13 12.8756 78.7274 23.4413 59.7273C33.8727 40.5694 51.5673 26.4075 72.5462 20.4273C73.234 20.2325 73.6158 20.1012 74.2273 20.442C74.3028 20.9998 72.097 23.2514 71.5628 23.8785C67.5026 28.6444 65.4533 33.0547 63.4777 38.8504C61.8468 39.8095 60.2815 40.8763 58.7919 42.042C43.3582 54.178 33.3134 71.8929 30.8211 91.3651C28.218 111.568 33.3828 129.929 45.765 145.977C49.5501 150.65 53.9092 154.827 58.7385 158.41C67.3615 164.789 77.2674 168.868 88.0694 169.329C94.8106 169.616 100.979 168.644 105.209 162.682C107.015 160.115 108.093 157.107 108.329 153.978C109.292 142.572 100.357 134.05 92.7125 126.897C88.4197 122.904 83.8462 119.071 79.5159 115.13C69.0339 105.589 57.6601 95.1262 55.5235 80.3593C54.4404 72.877 55.3169 65.4066 57.9365 58.3035C58.3658 57.1393 59.0062 55.0028 59.7064 54.0216L59.9363 53.9994C60.2437 54.6664 60.8081 58.1028 61.0866 59.1903C61.7902 61.9377 62.7798 64.7057 64.0662 67.2598C72.0303 83.0713 87.391 94.1406 100.059 106.202C112.101 117.667 124.309 128.907 125.278 146.796C125.739 155.307 122.702 163.976 116.869 170.165C110.071 177.38 101.347 180.522 91.5742 180.82Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="svg-1137231340_6119_paint0_linear_1843_2573"
                x1="97.8957"
                y1="0"
                x2="46.0375"
                y2="179.202"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            id="svg-1839680863_948"
          >
            <path
              d="M9.90033 7.61699C10.967 7.66699 11.242 8.57533 11.2587 9.00033H12.7503C12.6837 7.35033 11.5087 6.34199 9.87533 6.34199C8.03366 6.34199 6.66699 7.50033 6.66699 10.117C6.66699 11.7337 7.44199 13.6503 9.86699 13.6503C11.717 13.6503 12.7087 12.2753 12.7337 11.192H11.242C11.217 11.6837 10.867 12.342 9.88366 12.392C8.79199 12.3587 8.33366 11.5087 8.33366 10.117C8.33366 7.70866 9.40033 7.63366 9.90033 7.61699ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667Z"
              fill="#666D80"
            />
          </svg>
          <svg
            width="121"
            height="38"
            viewBox="0 0 121 38"
            fill="none"
            id="svg-1756771329_4687"
          >
            <path
              d="M51.5769 15.8841L48.7769 15.3579C46.9278 14.9895 46.5052 14.779 46.5052 13.7791C46.5052 12.7792 47.1391 12.3582 49.1995 12.3582C51.5241 12.3582 52.2109 12.8844 52.2109 14.5685V14.8316L55.6978 13.8843C55.4336 11.1478 53.4789 9.14795 49.3052 9.14795C44.7617 9.14795 43.0183 11.5161 43.0183 13.937C43.0183 16.4104 44.2863 17.8839 47.2976 18.4102L50.0977 18.8838C52.3166 19.2522 52.5807 19.6206 52.5807 20.6731C52.5807 21.7257 52.1053 22.1467 50.0448 22.1467C47.192 22.1467 46.558 21.673 46.558 19.9364V19.6732L43.0711 20.6205C43.3353 23.7255 45.5014 25.3569 49.8335 25.3569C54.3242 25.3569 56.0148 23.0939 56.0148 20.5679C56.0676 18.3049 54.9053 16.5683 51.5769 15.8841Z"
              fill="black"
            />
            <path
              d="M68.8003 18.1995V17.9364C68.8003 15.0419 66.4758 13.0947 63.3059 13.0947C59.3436 13.0947 57.0718 15.5155 57.0718 19.3046C57.0718 23.0411 59.1851 25.4093 63.0946 25.4093C66.3701 25.4093 68.7475 23.4621 68.7475 20.5677V20.3045H65.2078V20.4624C65.2078 21.7781 64.4682 22.2517 62.9889 22.2517C61.2983 22.2517 60.5587 21.4623 60.5587 19.252C60.5587 17.0417 61.2983 16.2523 62.9889 16.2523C64.4682 16.2523 65.2078 16.6733 65.2078 18.0416V18.2521H68.8003V18.1995Z"
              fill="black"
            />
            <path
              d="M75.932 13.042C72.6037 13.042 70.3848 14.8839 70.3848 17.7257V17.9889L73.7659 17.7257C73.7659 16.5153 74.3471 16.147 75.7735 16.147C77.1471 16.147 77.9396 16.4101 77.9396 17.7784V18.1468L73.8716 18.7783C71.4414 19.1467 70.1206 20.3044 70.1206 22.0937C70.1206 24.2514 71.7584 25.3566 73.8716 25.3566C76.0905 25.3566 77.2528 24.4093 77.9396 23.5146H78.0981V25.0934H81.3736V18.0941C81.268 14.9892 79.4189 13.042 75.932 13.042ZM74.9811 22.6726C73.9244 22.6726 73.449 22.4621 73.449 21.8306C73.449 21.357 73.7659 21.0938 74.5056 20.9886L77.8868 20.4623C77.8868 22.3042 76.4075 22.6726 74.9811 22.6726Z"
              fill="black"
            />
            <path
              d="M83.3811 10.3057V25.1463H86.9208V9.3584L83.3811 10.3057Z"
              fill="black"
            />
            <path
              d="M89.1398 10.3057V25.1463H92.6795V9.3584L89.1398 10.3057Z"
              fill="black"
            />
            <path
              d="M100.392 13.0425C104.196 13.0425 106.415 15.4633 106.415 19.1997C106.415 22.9362 104.196 25.3569 100.392 25.3569C96.5882 25.3568 94.3167 22.9361 94.3167 19.1997C94.3167 15.4634 96.5883 13.0426 100.392 13.0425ZM100.5 15.9272C98.6956 15.9272 97.2269 17.395 97.2268 19.1997C97.2268 21.0044 98.6955 22.4731 100.5 22.4731C100.769 22.4731 101.043 22.4391 101.312 22.3677C101.366 22.3551 101.417 22.3169 101.443 22.2622L101.496 22.1587C101.889 21.3991 102.557 20.8185 103.365 20.5376C103.449 20.5082 103.504 20.4325 103.504 20.3442V18.0513C103.504 17.963 103.449 17.8873 103.365 17.8579C102.557 17.5771 101.889 16.9961 101.499 16.2358L101.447 16.1333C101.421 16.0829 101.371 16.0447 101.317 16.0278C101.047 15.9605 100.774 15.9273 100.5 15.9272Z"
              fill="black"
            />
            <path
              d="M114.973 13.042C113.177 13.042 111.804 13.7261 111.17 15.0418H111.064V13.3051H107.788V29.093L111.328 28.1458V23.5673H111.434C111.962 24.5672 113.124 25.3566 115.026 25.3566C118.249 25.3566 120.045 22.9358 120.045 19.1993C120.098 15.4628 118.302 13.042 114.973 13.042ZM113.917 22.3569C112.226 22.3569 111.328 21.778 111.328 20.1466V18.252C111.328 16.6732 112.279 16.0417 113.917 16.0417C115.977 16.0417 116.506 17.0416 116.506 19.1993C116.506 21.357 115.977 22.3569 113.917 22.3569Z"
              fill="black"
            />
            <path
              d="M25.0748 5.98843C22.7229 8.41155 20.3711 10.8258 18.0192 13.2489C17.9925 13.2667 17.9747 13.2845 17.948 13.3112L12.8256 18.4336C12.3356 18.9236 12.3356 19.7343 12.8256 20.2243L17.6807 25.0794L11.7031 31.3421C10.7766 30.7096 9.89466 29.9791 9.02162 29.0972C2.75892 22.8434 2.54512 15.1108 8.85236 8.79461C13.85 3.79693 19.7475 2.95062 25.0748 5.98843Z"
              fill="url(#svg-1756771329_4687_paint0_linear_39_9540)"
            />
            <path
              d="M29.2796 29.2128C24.2908 34.1927 18.429 35.0836 13.1373 32.2239L15.2397 30.0235C16.8522 28.3576 18.4557 26.7006 20.0682 25.0347L21.6895 23.4134L24.8699 20.233C25.3598 19.7431 25.3598 18.9324 24.8699 18.4424L23.4089 16.9814L20.0503 13.6229L25.9656 7.43148L26.4823 6.89697C27.3553 7.51166 28.2284 8.25107 29.0569 9.07956C35.2661 15.271 35.5334 22.9501 29.2796 29.2128Z"
              fill="url(#svg-1756771329_4687_paint1_linear_39_9540)"
            />
            <defs>
              <linearGradient
                id="svg-1756771329_4687_paint0_linear_39_9540"
                x1="21.3346"
                y1="-5.73425"
                x2="-18.5026"
                y2="81.306"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#00DECA" />
                <stop offset="0.37798" stopColor="#3A8AFA" />
                <stop offset="1" stopColor="#1A6AF4" />
              </linearGradient>
              <linearGradient
                id="svg-1756771329_4687_paint1_linear_39_9540"
                x1="30.1297"
                y1="-2.99484"
                x2="-9.46262"
                y2="83.4647"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#00DECA" />
                <stop offset="0.37798" stopColor="#3A8AFA" />
                <stop offset="1" stopColor="#1A6AF4" />
              </linearGradient>
            </defs>
          </svg>
        </>
      </div>
      <>
        {/*$*/}
        <div
          data-framer-root=""
          className="framer-aDaRz framer-6lXp4 framer-1bpobwo refundpolicy-s1"
        >
          <div className="ssr-variant hidden-i1shqv">
            <div
              className="framer-1im3tfv-container hidden-1bpobwo refundpolicy-s2"
              data-framer-appear-id="1im3tfv"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-15zawlh refundpolicy-s3"
                data-framer-name="Desktop [Default Boxed]"
              >
                <header
                  className="framer-ooxjtq refundpolicy-s4"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 refundpolicy-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 refundpolicy-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz refundpolicy-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div
                        className="framer-1hg3ikx-container"
                        data-framer-name="Menu [Desktop]"
                        name="Menu [Desktop]"
                      >
                        <div
                          name="Menu [Desktop]"
                          className="framer-n0D3w framer-1itjusz framer-v-1itjusz refundpolicy-s8"
                          data-framer-name="Menu"
                        >
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq refundpolicy-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/accounts"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi refundpolicy-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text refundpolicy-s11"
                                >
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq refundpolicy-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-pay"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi refundpolicy-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text refundpolicy-s11"
                                >
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq refundpolicy-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/cards"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi refundpolicy-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text refundpolicy-s11"
                                >
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq refundpolicy-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-plus"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi refundpolicy-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text refundpolicy-s11"
                                >
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq refundpolicy-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/helpdesk"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi refundpolicy-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text refundpolicy-s11"
                                >
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div
                        className="framer-16051d2"
                        data-framer-name="QR Overlay Trigger"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div className="framer-168591e-container">
                          <div
                            className="framer-wWHmH framer-ly6l8a framer-v-18roq29 refundpolicy-s12"
                            data-border="true"
                            data-framer-name="Variant 2"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1ebu3nm refundpolicy-s13 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text refundpolicy-s14"
                              >
                                Get Started
                              </p>
                            </div>
                            <div
                              className="framer-1u4w7ze refundpolicy-s15 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text refundpolicy-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-1bpobwo">
            <div
              className="framer-1im3tfv-container hidden-1bpobwo"
              data-framer-appear-id="1im3tfv"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l refundpolicy-s3"
                data-framer-name="Mobile"
              >
                <header
                  className="framer-ooxjtq refundpolicy-s17"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 refundpolicy-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 refundpolicy-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz refundpolicy-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div
                          className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi refundpolicy-s18"
                          data-framer-name="Mobile Menu"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-1cux5of refundpolicy-s19" />
                          <div className="framer-1w1bul6 refundpolicy-s19" />
                          <div className="framer-1ku2ucf refundpolicy-s20" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div
            className="framer-ayxgs-container hidden-i1shqv refundpolicy-s2"
            data-framer-appear-id="ayxgs"
            id="ayxgs"
          >
            <div
              className="framer-8MFL4 framer-15zawlh framer-v-15zawlh refundpolicy-s3"
              data-framer-name="Desktop [Default Boxed]"
            >
              <header
                className="framer-ooxjtq refundpolicy-s4"
                data-border="true"
                data-framer-name="Main Area"
              >
                <div
                  className="framer-p578i7 refundpolicy-s5"
                  data-framer-name="Background [Default]"
                />
                <div
                  className="framer-pc27k4 refundpolicy-s6"
                  data-framer-name="Background [Boxed Mini]"
                />
                <div className="framer-cjwofg" data-framer-name="Content">
                  {/*$*/}
                  <a className="framer-1jy87r1 framer-145ct8v" href="/">
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Logo + Logo Type"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-1hjthz refundpolicy-s7"
                      aria-hidden="true"
                    />
                  </a>
                  {/*/$*/}
                  <nav className="framer-xe9vp0" data-framer-name="Nav">
                    <div
                      className="framer-1hg3ikx-container"
                      data-framer-name="Menu [Desktop]"
                      name="Menu [Desktop]"
                    >
                      <div
                        name="Menu [Desktop]"
                        className="framer-n0D3w framer-1itjusz framer-v-1itjusz refundpolicy-s8"
                        data-framer-name="Menu"
                      >
                        {/*$*/}
                        <div className="framer-mquu2a-container">
                          {/*$*/}
                          <a
                            className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq refundpolicy-s9"
                            data-framer-name="Menu Item Simple"
                            data-highlight="true"
                            href="/accounts"
                            tabIndex={0}
                          >
                            <div
                              className="framer-19g30xi refundpolicy-s10 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text refundpolicy-s11"
                              >
                                Accounts{' '}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-1yixouk-container">
                          {/*$*/}
                          <a
                            className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq refundpolicy-s9"
                            data-framer-name="Menu Item Simple"
                            data-highlight="true"
                            href="/scallop-pay"
                            tabIndex={0}
                          >
                            <div
                              className="framer-19g30xi refundpolicy-s10 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text refundpolicy-s11"
                              >
                                Scallop Pay
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-wi7xty-container">
                          {/*$*/}
                          <a
                            className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq refundpolicy-s9"
                            data-framer-name="Menu Item Simple"
                            data-highlight="true"
                            href="/cards"
                            tabIndex={0}
                          >
                            <div
                              className="framer-19g30xi refundpolicy-s10 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text refundpolicy-s11"
                              >
                                Cards
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-1tpzm7c-container">
                          {/*$*/}
                          <a
                            className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq refundpolicy-s9"
                            data-framer-name="Menu Item Simple"
                            data-highlight="true"
                            href="/scallop-plus"
                            tabIndex={0}
                          >
                            <div
                              className="framer-19g30xi refundpolicy-s10 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text refundpolicy-s11"
                              >
                                Scallop+
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-u2qi4r-container">
                          {/*$*/}
                          <a
                            className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq refundpolicy-s9"
                            data-framer-name="Menu Item Simple"
                            data-highlight="true"
                            href="/helpdesk"
                            tabIndex={0}
                          >
                            <div
                              className="framer-19g30xi refundpolicy-s10 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text refundpolicy-s11"
                              >
                                FAQs
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </nav>
                  <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                    <div
                      className="framer-16051d2"
                      data-framer-name="QR Overlay Trigger"
                      data-highlight="true"
                      tabIndex={0}
                    >
                      <div className="framer-168591e-container">
                        <div
                          className="framer-wWHmH framer-ly6l8a framer-v-18roq29 refundpolicy-s12"
                          data-border="true"
                          data-framer-name="Variant 2"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div
                            className="framer-1ebu3nm refundpolicy-s13 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text refundpolicy-s14"
                            >
                              Get Started
                            </p>
                          </div>
                          <div
                            className="framer-1u4w7ze refundpolicy-s15 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text refundpolicy-s16">
                              Coming soon
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </header>
            </div>
          </div>
          <div className="framer-caezkq" data-framer-name="Hero" id="hero">
            <div className="framer-16573lk" data-framer-name="Section">
              <div className="framer-1q91lzm" data-framer-name="Container">
                <div className="framer-1fpqscc" data-framer-name="Content">
                  <div
                    className="framer-k4p8ug refundpolicy-s21 reveal"
                    data-framer-name="Date"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s22">
                      Last update: Feb 2026
                    </p>
                  </div>
                  <div className="framer-1pej7vf" data-framer-name="Container">
                    <div className="ssr-variant hidden-i1shqv">
                      <div
                        className="framer-rgtb33 refundpolicy-s21 reveal"
                        data-framer-name="Empowering your business for tomorrow."
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 dir="auto" className="framer-text refundpolicy-s23">
                          Refunds and Chargebacks Policy
                        </h1>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1bpobwo">
                      <div
                        className="framer-rgtb33 refundpolicy-s21 reveal"
                        data-framer-name="Empowering your business for tomorrow."
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1 dir="auto" className="framer-text refundpolicy-s24">
                          Refunds and Chargebacks Policy
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-18t1hdh" data-framer-name="Text">
            <div className="framer-1am10m2" data-framer-name="Section">
              <div className="framer-1ormuj9" data-framer-name="Content">
                <div className="framer-ixgl8m" data-framer-name="Container">
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-zhg6nl refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s25">
                        In this Policy, &ldquo;Scallop&rdquo;, &ldquo;we&rdquo;,
                        &ldquo;us&rdquo; and &ldquo;our&rdquo; refer to the
                        Scallop Group, acting through the relevant entity
                        involved in the provision, operation, or support of the
                        services offered through the Platform.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-zhg6nl refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s26">
                        In this Policy, &ldquo;Scallop&rdquo;, &ldquo;we&rdquo;,
                        &ldquo;us&rdquo; and &ldquo;our&rdquo; refer to the
                        Scallop Group, acting through the relevant entity
                        involved in the provision, operation, or support of the
                        services offered through the Platform.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-k6qnoa refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        1. Scope and general principle
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-k6qnoa refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        1. Scope and general principle
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-aakqtm refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s25">
                        This Refunds and Chargebacks Policy explains how
                        refunds, reversals, chargebacks, and recovery requests
                        are handled in connection with the Scallop platform.
                        <br className="framer-text" />
                        Scallop is a financial technology platform and not an
                        online retailer. Services provided through the Platform
                        involve regulated financial transactions, digital
                        assets, payment processing, and third-party
                        infrastructure. As a general principle, transactions
                        executed through the Platform are final and
                        non-refundable, except where required by applicable law
                        or expressly stated in this Policy.
                        <br className="framer-text" />
                        This Policy should be read together with the Terms and
                        Conditions and applies to all users of the Platform.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-aakqtm refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s26">
                        This Refunds and Chargebacks Policy explains how
                        refunds, reversals, chargebacks, and recovery requests
                        are handled in connection with the Scallop platform.
                        <br className="framer-text" />
                        Scallop is a financial technology platform and not an
                        online retailer. Services provided through the Platform
                        involve regulated financial transactions, digital
                        assets, payment processing, and third-party
                        infrastructure. As a general principle, transactions
                        executed through the Platform are final and
                        non-refundable, except where required by applicable law
                        or expressly stated in this Policy.
                        <br className="framer-text" />
                        This Policy should be read together with the Terms and
                        Conditions and applies to all users of the Platform.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-fy4nxg refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        2. No general right to refunds
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-fy4nxg refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        2. No general right to refunds
                      </h2>
                    </div>
                  </div>
                  <div className="framer-qc1olc">
                    <div className="ssr-variant hidden-i1shqv">
                      <div
                        className="framer-l67030 refundpolicy-s21 reveal"
                        data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text refundpolicy-s29">
                          Unless expressly required by applicable law, Scallop
                          does not offer refunds for completed transactions,
                          including but not limited to:
                        </p>
                        <ul dir="auto" className="framer-text refundpolicy-s29">
                          <li data-preset-tag="p" className="framer-text">
                            <p className="framer-text">fiat transfers</p>
                          </li>
                          <li data-preset-tag="p" className="framer-text">
                            <p className="framer-text">
                              digital asset transactions
                            </p>
                          </li>
                          <li data-preset-tag="p" className="framer-text">
                            <p className="framer-text">swaps or exchanges</p>
                          </li>
                          <li data-preset-tag="p" className="framer-text">
                            <p className="framer-text">
                              card-related transactions
                            </p>
                          </li>
                          <li data-preset-tag="p" className="framer-text">
                            <p className="framer-text">
                              fees charged for services
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1bpobwo">
                      <div
                        className="framer-l67030 refundpolicy-s21 reveal"
                        data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text refundpolicy-s30">
                          Unless expressly required by applicable law, Scallop
                          does not offer refunds for completed transactions,
                          including but not limited to:
                        </p>
                        <ul dir="auto" className="framer-text refundpolicy-s30">
                          <li data-preset-tag="p" className="framer-text">
                            <p className="framer-text">fiat transfers</p>
                          </li>
                          <li data-preset-tag="p" className="framer-text">
                            <p className="framer-text">
                              digital asset transactions
                            </p>
                          </li>
                          <li data-preset-tag="p" className="framer-text">
                            <p className="framer-text">swaps or exchanges</p>
                          </li>
                          <li data-preset-tag="p" className="framer-text">
                            <p className="framer-text">
                              card-related transactions
                            </p>
                          </li>
                          <li data-preset-tag="p" className="framer-text">
                            <p className="framer-text">
                              fees charged for services
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-i1shqv">
                      <div
                        className="framer-1l8tjfj refundpolicy-s21 reveal"
                        data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text refundpolicy-s29">
                          Users acknowledge that financial transactions, once
                          authorised and executed, cannot generally be reversed.
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1bpobwo">
                      <div
                        className="framer-1l8tjfj refundpolicy-s21 reveal"
                        data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text refundpolicy-s30">
                          Users acknowledge that financial transactions, once
                          authorised and executed, cannot generally be reversed.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-pk1h4t refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        3. Fiat transactions and bank transfers
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-pk1h4t refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        3. Fiat transactions and bank transfers
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-1j0g15y refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        <strong className="framer-text">
                          3.1 Incorrect or mistaken transfers -
                          <br className="framer-text" />
                        </strong>
                        If a user initiates a fiat transfer to an incorrect
                        beneficiary, incorrect account details, or an account
                        not owned by the user, Scallop is not responsible for
                        the loss of funds.
                        <br className="framer-text" />
                        Scallop may, where technically and legally possible,
                        assist the user in attempting to recover the funds.
                        Recovery is not guaranteed and depends on third-party
                        banks or payment service providers. Any assistance
                        provided may be subject to administrative or processing
                        fees.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-1j0g15y refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        <strong className="framer-text">
                          3.1 Incorrect or mistaken transfers -
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        If a user initiates a fiat transfer to an incorrect
                        beneficiary, incorrect account details, or an account
                        not owned by the user, Scallop is not responsible for
                        the loss of funds.
                        <br className="framer-text" />
                        Scallop may, where technically and legally possible,
                        assist the user in attempting to recover the funds.
                        Recovery is not guaranteed and depends on third-party
                        banks or payment service providers. Any assistance
                        provided may be subject to administrative or processing
                        fees.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-f48way refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        <strong className="framer-text">
                          3.2 Temporary and dynamic virtual accounts -
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        In certain jurisdictions, deposits may be made via
                        temporary or dynamic virtual accounts. These accounts
                        are generated for one-time or limited use only.
                        <br className="framer-text" />
                        If a user attempts to reuse a temporary virtual account
                        or adds it as a beneficiary for future transfers, such
                        transfers may fail or be rejected. Scallop may assist in
                        investigating such cases but does not guarantee recovery
                        of funds.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-f48way refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        <strong className="framer-text">
                          3.2 Temporary and dynamic virtual accounts -
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        In certain jurisdictions, deposits may be made via
                        temporary or dynamic virtual accounts. These accounts
                        are generated for one-time or limited use only.
                        <br className="framer-text" />
                        If a user attempts to reuse a temporary virtual account
                        or adds it as a beneficiary for future transfers, such
                        transfers may fail or be rejected. Scallop may assist in
                        investigating such cases but does not guarantee recovery
                        of funds.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-1h0owgp refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        4. Card-related transactions
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-1h0owgp refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        4. Card-related transactions
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-p705t2 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        <strong className="framer-text">
                          4.1 Virtual and physical cards -{' '}
                          <br className="framer-text" />
                        </strong>
                        Once funds are deposited to a virtual or physical card
                        issued or supported through the Platform, such funds are
                        generally non-refundable.
                        <br className="framer-text" />
                        Scallop cannot reverse or refund card funding
                        transactions once they have been successfully completed.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-p705t2 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        <strong className="framer-text">
                          4.1 Virtual and physical cards -{' '}
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        Once funds are deposited to a virtual or physical card
                        issued or supported through the Platform, such funds are
                        generally non-refundable.
                        <br className="framer-text" />
                        Scallop cannot reverse or refund card funding
                        transactions once they have been successfully completed.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-14lm77l refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        <strong className="framer-text">
                          4.2 Chargebacks -<br className="framer-text" />
                        </strong>
                        Chargebacks are governed by the rules of the relevant
                        card scheme and card issuer. Scallop does not control
                        chargeback decisions and is not responsible for outcomes
                        determined by card networks or issuers.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-14lm77l refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        <strong className="framer-text">
                          4.2 Chargebacks -
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        Chargebacks are governed by the rules of the relevant
                        card scheme and card issuer. Scallop does not control
                        chargeback decisions and is not responsible for outcomes
                        determined by card networks or issuers.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-oko0nn refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        5. Digital assets and crypto transactions
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-oko0nn refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        5. Digital assets and crypto transactions
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-195p1ad refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        <strong className="framer-text">
                          5.1 Irreversibility -{' '}
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        All digital asset transactions are final and
                        irreversible once executed on the relevant blockchain or
                        system. Scallop cannot reverse, cancel, or recover
                        digital asset transactions once they have been
                        confirmed.
                        <br className="framer-text" />
                        <br className="framer-text" />
                        <strong className="framer-text">
                          5.2 Wrong network deposits -{' '}
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        If a user deposits digital assets using an unsupported
                        or incorrect blockchain network, Scallop is generally
                        unable to recover such assets. Where, and only where,
                        the relevant custody or infrastructure provider used by
                        Scallop supports the blockchain network in question,
                        Scallop may, at its discretion, attempt a manual
                        recovery of the digital assets following the submission
                        of a support ticket by the user.
                        <br className="framer-text" />
                        <br className="framer-text trailing-break" />
                      </p>
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        Any such recovery attempt is subject to:
                      </p>
                      <ul dir="auto" className="framer-text refundpolicy-s29">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">technical feasibility</p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">third-party cooperation</p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">manual intervention</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-195p1ad refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        <strong className="framer-text">
                          5.1 Irreversibility -{' '}
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        All digital asset transactions are final and
                        irreversible once executed on the relevant blockchain or
                        system. Scallop cannot reverse, cancel, or recover
                        digital asset transactions once they have been
                        confirmed.
                        <br className="framer-text" />
                        <br className="framer-text" />
                        <strong className="framer-text">
                          5.2 Wrong network deposits -{' '}
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        If a user deposits digital assets using an unsupported
                        or incorrect blockchain network, Scallop is generally
                        unable to recover such assets. Where, and only where,
                        the relevant custody or infrastructure provider used by
                        Scallop supports the blockchain network in question,
                        Scallop may, at its discretion, attempt a manual
                        recovery of the digital assets following the submission
                        of a support ticket by the user.
                        <br className="framer-text" />
                        <br className="framer-text trailing-break" />
                      </p>
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        Any such recovery attempt is subject to:
                      </p>
                      <ul dir="auto" className="framer-text refundpolicy-s30">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">technical feasibility</p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">third-party cooperation</p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">manual intervention</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-idm8a8 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        Recovery is not guaranteed and may take several business
                        days or longer to complete. A processing or recovery fee
                        of USD 50 applies per case and must be paid prior to any
                        recovery attempt.
                        <br className="framer-text" />
                        <br className="framer-text" />
                        <strong className="framer-text">
                          5.3 Swaps and exchanges -{' '}
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        The following transactions are strictly non-refundable:
                      </p>
                      <ul dir="auto" className="framer-text refundpolicy-s29">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">crypto to crypto swaps</p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">fiat to crypto swaps</p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">crypto to fiat swaps</p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            addition of funds or collateral injection to virtual
                            or physical cards
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-idm8a8 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        Recovery is not guaranteed and may take several business
                        days or longer to complete. A processing or recovery fee
                        of USD 50 applies per case and must be paid prior to any
                        recovery attempt.
                        <br className="framer-text" />
                        <br className="framer-text" />
                        <strong className="framer-text">
                          5.3 Swaps and exchanges -{' '}
                        </strong>
                        <strong className="framer-text">
                          <br className="framer-text" />
                        </strong>
                        The following transactions are strictly non-refundable:
                      </p>
                      <ul dir="auto" className="framer-text refundpolicy-s30">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">crypto to crypto swaps</p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">fiat to crypto swaps</p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">crypto to fiat swaps</p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            addition of funds or collateral injection to virtual
                            or physical cards
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-1qb7uhs refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        6. Unauthorised transactions
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-1qb7uhs refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        6. Unauthorised transactions
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-1qcn2pl refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        If a transaction is unauthorised due to loss or theft of
                        a payment instrument, the user must notify Customer
                        Support immediately. User liability and any potential
                        refund are governed by applicable mandatory law and the
                        Terms and Conditions. Refunds, where legally required,
                        are processed in accordance with regulatory timelines.
                        <br className="framer-text" />
                        <br className="framer-text" />
                        Scallop is not responsible for losses resulting from:
                      </p>
                      <ul dir="auto" className="framer-text refundpolicy-s29">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            disclosure of login credentials
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            phishing or social engineering
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            unauthorised access caused by user negligence
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-1qcn2pl refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        If a transaction is unauthorised due to loss or theft of
                        a payment instrument, the user must notify Customer
                        Support immediately. User liability and any potential
                        refund are governed by applicable mandatory law and the
                        Terms and Conditions. Refunds, where legally required,
                        are processed in accordance with regulatory timelines.
                        <br className="framer-text" />
                        <br className="framer-text" />
                        Scallop is not responsible for losses resulting from:
                      </p>
                      <ul dir="auto" className="framer-text refundpolicy-s30">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            disclosure of login credentials
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            phishing or social engineering
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            unauthorised access caused by user negligence
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-1xlkvpk refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        7. Account tiers and usage limitations
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-1xlkvpk refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        7. Account tiers and usage limitations
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-oyei4g refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        Certain account tiers are subject to usage restrictions.
                        <br className="framer-text" />
                        For example, Voyager Tier 1 accounts are designed for
                        personal, self-use only and support transfers to
                        accounts in the user&rsquo;s own name. If a user
                        attempts to transfer funds to third-party accounts or
                        virtual accounts not held in their name, funds may be
                        frozen or rejected by third parties. Scallop is not
                        responsible for such freezes or losses. Where a user
                        requests statements or confirmations to support
                        third-party investigations, Scallop may charge a fixed
                        administrative fee.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-oyei4g refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        Certain account tiers are subject to usage restrictions.
                        <br className="framer-text" />
                        For example, Voyager Tier 1 accounts are designed for
                        personal, self-use only and support transfers to
                        accounts in the user&rsquo;s own name. If a user
                        attempts to transfer funds to third-party accounts or
                        virtual accounts not held in their name, funds may be
                        frozen or rejected by third parties. Scallop is not
                        responsible for such freezes or losses. Where a user
                        requests statements or confirmations to support
                        third-party investigations, Scallop may charge a fixed
                        administrative fee.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-1nmxgm8 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        8. Fees and administrative charges
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-1nmxgm8 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        8. Fees and administrative charges
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-ybe7a3 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        All fees charged for services, investigations, recovery
                        attempts, documentation, or administrative support are
                        non-refundable unless otherwise required by applicable
                        law.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-ybe7a3 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        All fees charged for services, investigations, recovery
                        attempts, documentation, or administrative support are
                        non-refundable unless otherwise required by applicable
                        law.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-1qhkfln refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        9. Third-party services
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-1qhkfln refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        9. Third-party services
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-1fvwoa1 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        Scallop relies on third-party banks, payment service
                        providers, card issuers, and blockchain networks.
                        Scallop is not responsible for refunds, reversals, or
                        delays caused by third parties. Any assistance provided
                        by Scallop in such cases is on a reasonable effort basis
                        only.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-1fvwoa1 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        Scallop relies on third-party banks, payment service
                        providers, card issuers, and blockchain networks.
                        Scallop is not responsible for refunds, reversals, or
                        delays caused by third parties. Any assistance provided
                        by Scallop in such cases is on a reasonable effort basis
                        only.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-2fzgey refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        9. Third-party services
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-2fzgey refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        9. Third-party services
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-2qtwvb refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        Scallop relies on third-party banks, payment service
                        providers, card issuers, and blockchain networks.
                        Scallop is not responsible for refunds, reversals, or
                        delays caused by third parties. Any assistance provided
                        by Scallop in such cases is on a reasonable effort basis
                        only.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-2qtwvb refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        Scallop relies on third-party banks, payment service
                        providers, card issuers, and blockchain networks.
                        Scallop is not responsible for refunds, reversals, or
                        delays caused by third parties. Any assistance provided
                        by Scallop in such cases is on a reasonable effort basis
                        only.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-znvx52 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        10. How to request assistance
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-znvx52 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        10. How to request assistance
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-swt0jm refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        Users may contact Customer Support via the Platform or
                        at support@scallopx.com to report issues or request
                        assistance. Users acknowledge that submitting a request
                        does not guarantee a refund or recovery
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-swt0jm refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        Users may contact Customer Support via the Platform or
                        at support@scallopx.com to report issues or request
                        assistance. Users acknowledge that submitting a request
                        does not guarantee a refund or recovery
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-1xg4sm refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s27">
                        11. Policy updates
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-1xg4sm refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text refundpolicy-s28">
                        11. Policy updates
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-i1shqv">
                    <div
                      className="framer-nsenk9 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s29">
                        This Policy may be updated from time to time. The latest
                        version will always be available on the Platform.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1bpobwo">
                    <div
                      className="framer-nsenk9 refundpolicy-s21 reveal"
                      data-framer-name="Find quick answers about our services. Reach out to us directly for more information!"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s30">
                        This Policy may be updated from time to time. The latest
                        version will always be available on the Platform.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-s3lhwu-container hidden-i1shqv">
            <div
              className="framer-60Kb5 framer-1rilglu framer-v-1rilglu refundpolicy-s31"
              data-framer-name="Desktop"
            >
              <div className="framer-14npji9" data-framer-name="Frame 33595">
                <div className="framer-1nbyyte">
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="Logo + Logo Type"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-1ick3k6 refundpolicy-s32"
                    aria-hidden="true"
                  >
                    <div className="svgContainer refundpolicy-s33">
                      <svg viewBox="0 0 699 196" className="refundpolicy-s34">
                        <use href="#svg-1137231340_6119" />
                      </svg>
                    </div>
                  </div>
                  <div className="framer-6st60f">
                    <div
                      className="framer-9nwe5k refundpolicy-s35 reveal"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s36">
                        <strong className="framer-text">
                          One account for all your currencies{' '}
                          <br className="framer-text" />
                        </strong>
                        Manage, send, and receive money globally
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-1d0k7xa"
                    data-framer-name="ICO Logo_Blue"
                  >
                    <div
                      data-framer-background-image-wrapper="true"
                      className="refundpolicy-s37"
                    >
                      <img
                        decoding="async"
                        width="1440"
                        height="1440"
                        sizes="(min-width: 1400px) 60px, (max-width: 1399.98px) 60px"
                        srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                        src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                        alt=""
                        className="refundpolicy-s38"
                      />
                    </div>
                  </div>
                  <div className="scallop-compliance-note">
                    <p>
                      This website is managed by Scallop Pvt Limited, Sri Lanka.
                      <br />
                      Scallop does not provide services in the countries listed on
                      its{' '}
                      <a
                        href="https://docs.scallopx.com/details/onboarding-regions"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Prohibited Countries list
                      </a>
                      .
                    </p>
                  </div>
                </div>
                <div className="framer-c50yne" data-framer-name="Frame 33594">
                  <div className="framer-5dec6k" data-framer-name="Menu">
                    <div
                      className="framer-nmphiu refundpolicy-s39 reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s40">
                        Programs
                      </p>
                    </div>
                    <div className="framer-1odpfed" data-framer-name="List">
                      {/*$*/}
                      <div className="framer-1tz9h0j-container">
                        {/*$*/}
                        <a
                          className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                          data-framer-name="Link"
                          href="/ambassador"
                        >
                          <div
                            className="framer-wlx7jb refundpolicy-s39 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text refundpolicy-s41">
                              {/*$*/}
                              <span
                                className="framer-text framer-styles-preset-11r53mh"
                                data-styles-preset="LO9i42feF"
                                href="/ambassador"
                                data-nested-link="true"
                                role="link"
                                tabIndex={0}
                              >
                                Ambassador
                              </span>
                              {/*/$*/}
                            </p>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                      {/*/$*/}
                    </div>
                  </div>
                  <div className="framer-a8htgk" data-framer-name="Menu">
                    <div
                      className="framer-1rugbzn refundpolicy-s39 reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s40">
                        Products
                      </p>
                    </div>
                    <div className="framer-1oe4fxe" data-framer-name="List">
                      {/*$*/}
                      <div className="framer-153yqwe-container">
                        {/*$*/}
                        <a
                          className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                          data-framer-name="Link"
                          href="/accounts"
                        >
                          <div
                            className="framer-wlx7jb refundpolicy-s39 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text refundpolicy-s41">
                              {/*$*/}
                              <span
                                className="framer-text framer-styles-preset-11r53mh"
                                data-styles-preset="LO9i42feF"
                                href="/accounts"
                                data-nested-link="true"
                                role="link"
                                tabIndex={0}
                              >
                                Accounts
                              </span>
                              {/*/$*/}
                            </p>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                      {/*/$*/}
                      {/*$*/}
                      <div className="framer-1di1zw4-container">
                        {/*$*/}
                        <a
                          className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                          data-framer-name="Link"
                          href="/cards"
                        >
                          <div
                            className="framer-wlx7jb refundpolicy-s39 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text refundpolicy-s41">
                              {/*$*/}
                              <span
                                className="framer-text framer-styles-preset-11r53mh"
                                data-styles-preset="LO9i42feF"
                                href="/cards"
                                data-nested-link="true"
                                role="link"
                                tabIndex={0}
                              >
                                Cards
                              </span>
                              {/*/$*/}
                            </p>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                      {/*/$*/}
                      {/*$*/}
                      <div className="framer-165n05h-container">
                        {/*$*/}
                        <a
                          className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                          data-framer-name="Link"
                          href="/scallop-pay"
                        >
                          <div
                            className="framer-wlx7jb refundpolicy-s39 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text refundpolicy-s41">
                              {/*$*/}
                              <span
                                className="framer-text framer-styles-preset-11r53mh"
                                data-styles-preset="LO9i42feF"
                                href="/scallop-pay"
                                data-nested-link="true"
                                role="link"
                                tabIndex={0}
                              >
                                Scallop Pay
                              </span>
                              {/*/$*/}
                            </p>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                      {/*/$*/}
                      {/*$*/}
                      <div className="framer-1ddhrxh-container">
                        {/*$*/}
                        <a
                          className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                          data-framer-name="Link"
                          href="/scallop-plus"
                        >
                          <div
                            className="framer-wlx7jb refundpolicy-s39 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text refundpolicy-s41">
                              {/*$*/}
                              <span
                                className="framer-text framer-styles-preset-11r53mh"
                                data-styles-preset="LO9i42feF"
                                href="/scallop-plus"
                                data-nested-link="true"
                                role="link"
                                tabIndex={0}
                              >
                                Scallop Plus
                              </span>
                              {/*/$*/}
                            </p>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                      {/*/$*/}
                      <div className="framer-nsl31k-container">
                        {/*$*/}
                        <a
                          className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                          data-framer-name="Link"
                          href="https://blog.scallopx.com/"
                        >
                          <div
                            className="framer-wlx7jb refundpolicy-s39 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text refundpolicy-s41">
                              {/*$*/}
                              <span
                                className="framer-text framer-styles-preset-11r53mh"
                                data-styles-preset="LO9i42feF"
                                href="https://blog.scallopx.com/"
                                rel="noopener"
                                data-nested-link="true"
                                role="link"
                                tabIndex={0}
                              >
                                Blogs
                              </span>
                              {/*/$*/}
                            </p>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                  <div className="framer-bcfdyi" data-framer-name="Menu">
                    <div
                      className="framer-cv5tks refundpolicy-s39 reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s40">
                        Support
                      </p>
                    </div>
                    <div className="framer-16j5a70" data-framer-name="List">
                      {/*$*/}
                      <div className="framer-1apiy1v-container">
                        {/*$*/}
                        <a
                          className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                          data-framer-name="Link"
                          href="/support"
                        >
                          <div
                            className="framer-wlx7jb refundpolicy-s39 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text refundpolicy-s41">
                              {/*$*/}
                              <span
                                className="framer-text framer-styles-preset-11r53mh"
                                data-styles-preset="LO9i42feF"
                                href="/support"
                                data-nested-link="true"
                                role="link"
                                tabIndex={0}
                              >
                                Contact Us
                              </span>
                              {/*/$*/}
                            </p>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                      {/*/$*/}
                      {/*$*/}
                      <div className="framer-650678-container">
                        {/*$*/}
                        <a
                          className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                          data-framer-name="Link"
                          href="/helpdesk"
                        >
                          <div
                            className="framer-wlx7jb refundpolicy-s39 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text refundpolicy-s41">
                              {/*$*/}
                              <span
                                className="framer-text framer-styles-preset-11r53mh"
                                data-styles-preset="LO9i42feF"
                                href="/helpdesk"
                                data-nested-link="true"
                                role="link"
                                tabIndex={0}
                              >
                                FAQs
                              </span>
                              {/*/$*/}
                            </p>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                      {/*/$*/}
                      <div className="framer-1935128-container">
                        {/*$*/}
                        <a
                          className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                          data-framer-name="Link"
                          href="https://docs.scallopx.com/"
                        >
                          <div
                            className="framer-wlx7jb refundpolicy-s39 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p className="framer-text refundpolicy-s41">
                              {/*$*/}
                              <span
                                className="framer-text framer-styles-preset-11r53mh"
                                data-styles-preset="LO9i42feF"
                                href="https://docs.scallopx.com/"
                                rel="noopener"
                                data-nested-link="true"
                                role="link"
                                tabIndex={0}
                              >
                                Scallop Docs
                              </span>
                              {/*/$*/}
                            </p>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="framer-1l4w042" data-framer-name="Frame 33831">
                <div className="framer-jk8g5w" data-framer-name="Link">
                  <div className="framer-80yh0c">
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="ic:baseline-copyright"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-m3skko refundpolicy-s32"
                      aria-hidden="true"
                    >
                      <div className="svgContainer refundpolicy-s33">
                        <svg viewBox="0 0 20 20" className="refundpolicy-s34">
                          <use href="#svg-1839680863_948" />
                        </svg>
                      </div>
                    </div>
                    <div
                      className="framer-hv1cvb refundpolicy-s42 reveal"
                      data-framer-name="Item"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text refundpolicy-s43">
                        2026 Scallop Group. All rights reserved.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="framer-1c28m8b">
                  {/*$*/}
                  <a
                    data-framer-component-type="SVG"
                    as="a"
                    data-framer-name="X"
                    href="https://x.com/Scallopcom"
                    target="_blank"
                    rel="noopener"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-dziac9 framer-1d3y7cu refundpolicy-s44"
                    aria-hidden="true"
                  />
                  {/*/$*/}
                  {/*$*/}
                  <a
                    className="framer-n9nhin framer-1d3y7cu"
                    data-framer-name="LinkdIn"
                    href="https://www.linkedin.com/company/scallopcom"
                    target="_blank"
                    rel="noopener"
                  >
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="linkd"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-1ggemab refundpolicy-s45"
                      aria-hidden="true"
                    />
                  </a>
                  {/*/$*/}
                </div>
              </div>
            </div>
          </div>
          <div
            className="framer-17wvmz0 hidden-1bpobwo"
            data-framer-name="Mobile"
          >
            <div className="framer-15rym3g" data-framer-name="Frame 33595">
              <div className="framer-1qhqzmw">
                <div
                  data-framer-component-type="SVG"
                  data-framer-name="Logo"
                  parentsize="0"
                  _constraints="[object Object]"
                  rotation="0"
                  shadows=""
                  className="framer-dxryi5 refundpolicy-s32"
                  aria-hidden="true"
                >
                  <div className="svgContainer refundpolicy-s33">
                    <svg viewBox="0 0 121 38" className="refundpolicy-s34">
                      <use href="#svg-1756771329_4687" />
                    </svg>
                  </div>
                </div>
                <div className="framer-7d5u53">
                  <div
                    className="framer-vcigcp refundpolicy-s21 reveal"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s46">
                      Be the first to experience the{' '}
                      <strong className="framer-text">
                        future of digital banking.
                      </strong>
                    </p>
                  </div>
                  <div className="framer-h8ib32-container">
                    {/*$*/}
                    <a
                      className="framer-9PalM framer-6q7a9y framer-v-4uzvf5 framer-12rwjxo refundpolicy-s47"
                      data-border="true"
                      data-framer-name="Primary / Small"
                      data-highlight="true"
                      href="https://www.scallopx.com/waitlist/"
                      target="_blank"
                      rel="noopener"
                      tabIndex={0}
                    >
                      <div
                        className="framer-1bw53x4 refundpolicy-s48 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text refundpolicy-s16">
                          Join Waitlist
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                </div>
              </div>
              <div className="framer-52nsi8" data-framer-name="Frame 33594">
                <div className="framer-cvecwj" data-framer-name="Menu">
                  <div
                    className="framer-1hdz47p refundpolicy-s21 reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s49">
                      Laguage
                    </p>
                  </div>
                  <div className="framer-1n98851" data-framer-name="List">
                    {/*$*/}
                    <div className="framer-1jzxkdn-container">
                      {/*$*/}
                      <a
                        className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                        data-framer-name="Link"
                        href="/en-in"
                      >
                        <div
                          className="framer-wlx7jb refundpolicy-s39 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text refundpolicy-s41">
                            {/*$*/}
                            <span
                              className="framer-text framer-styles-preset-11r53mh"
                              data-styles-preset="LO9i42feF"
                              href="/en-in"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              en-in
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                    {/*$*/}
                    <div className="framer-1ei2zi1-container">
                      {/*$*/}
                      <a
                        className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                        data-framer-name="Link"
                        href="/old-home"
                      >
                        <div
                          className="framer-wlx7jb refundpolicy-s39 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text refundpolicy-s41">
                            {/*$*/}
                            <span
                              className="framer-text framer-styles-preset-11r53mh"
                              data-styles-preset="LO9i42feF"
                              href="/old-home"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              en-eu
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                    {/*$*/}
                    <div className="framer-ftd7jz-container">
                      {/*$*/}
                      <a
                        className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                        data-framer-name="Link"
                        href="/old-home"
                      >
                        <div
                          className="framer-wlx7jb refundpolicy-s39 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text refundpolicy-s41">
                            {/*$*/}
                            <span
                              className="framer-text framer-styles-preset-11r53mh"
                              data-styles-preset="LO9i42feF"
                              href="/old-home"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              en-ch
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="framer-1x91o6d" data-framer-name="Menu">
                  <div
                    className="framer-1pmsvlv refundpolicy-s21 reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s49">
                      Features
                    </p>
                  </div>
                  <div className="framer-algg6k" data-framer-name="List">
                    {/*$*/}
                    <div className="framer-frbepd-container">
                      {/*$*/}
                      <a
                        className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                        data-framer-name="Link"
                        href="./old-home#accounts"
                      >
                        <div
                          className="framer-wlx7jb refundpolicy-s39 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text refundpolicy-s41">
                            {/*$*/}
                            <span
                              className="framer-text framer-styles-preset-11r53mh"
                              data-styles-preset="LO9i42feF"
                              href="./old-home#accounts"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              Accounts
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                    {/*$*/}
                    <div className="framer-1b86p9r-container">
                      {/*$*/}
                      <a
                        className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                        data-framer-name="Link"
                        href="/cards"
                      >
                        <div
                          className="framer-wlx7jb refundpolicy-s39 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text refundpolicy-s41">
                            {/*$*/}
                            <span
                              className="framer-text framer-styles-preset-11r53mh"
                              data-styles-preset="LO9i42feF"
                              href="/cards"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              Cards
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                    <div className="framer-18og6la-container">
                      {/*$*/}
                      <a
                        className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                        data-framer-name="Link"
                        href="https://emoney.io/"
                      >
                        <div
                          className="framer-wlx7jb refundpolicy-s39 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text refundpolicy-s41">
                            {/*$*/}
                            <span
                              className="framer-text framer-styles-preset-11r53mh"
                              data-styles-preset="LO9i42feF"
                              href="https://emoney.io/"
                              rel="noopener"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              E Money Network
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
                <div className="framer-p0z2jm" data-framer-name="Menu">
                  <div
                    className="framer-s9l7te refundpolicy-s21 reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s49">
                      About
                    </p>
                  </div>
                  <div className="framer-6k9nsp" data-framer-name="List">
                    {/*$*/}
                    <div className="framer-kfl4r2-container">
                      {/*$*/}
                      <a
                        className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                        data-framer-name="Link"
                        href="./old-home#faqs"
                      >
                        <div
                          className="framer-wlx7jb refundpolicy-s39 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text refundpolicy-s41">
                            {/*$*/}
                            <span
                              className="framer-text framer-styles-preset-11r53mh"
                              data-styles-preset="LO9i42feF"
                              href="./old-home#faqs"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              FAQs
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                    <div className="framer-1neeed5-container">
                      {/*$*/}
                      <a
                        className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                        data-framer-name="Link"
                        href="https://x.com/emoney_network"
                      >
                        <div
                          className="framer-wlx7jb refundpolicy-s39 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text refundpolicy-s41">
                            {/*$*/}
                            <span
                              className="framer-text framer-styles-preset-11r53mh"
                              data-styles-preset="LO9i42feF"
                              href="https://x.com/emoney_network"
                              rel="noopener"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              Community
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*$*/}
                    <div className="framer-cdwj9p-container">
                      {/*$*/}
                      <a
                        className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                        data-framer-name="Link"
                        href="/support"
                      >
                        <div
                          className="framer-wlx7jb refundpolicy-s39 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p className="framer-text refundpolicy-s41">
                            {/*$*/}
                            <span
                              className="framer-text framer-styles-preset-11r53mh"
                              data-styles-preset="LO9i42feF"
                              href="/support"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              Contact Us
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1m49ikz" data-framer-name="Frame 33831">
              <div className="framer-zjoluz" data-framer-name="Link">
                <div className="framer-hjkhcn">
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="ic:baseline-copyright"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-1v84t9a refundpolicy-s32"
                    aria-hidden="true"
                  >
                    <div className="svgContainer refundpolicy-s33">
                      <svg viewBox="0 0 20 20" className="refundpolicy-s34">
                        <use href="#svg-1839680863_948" />
                      </svg>
                    </div>
                  </div>
                  <div
                    className="framer-1ns6r3z refundpolicy-s21 reveal"
                    data-framer-name="Item"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s50">
                      2026 Scallop Group. All rights reserved
                    </p>
                  </div>
                </div>
                <div className="framer-4qde7l">
                  <div
                    className="framer-is9gxa refundpolicy-s21 reveal"
                    data-framer-name="Item"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s51">
                      {/*$*/}
                      <a
                        className="framer-text framer-styles-preset-11r53mh"
                        data-styles-preset="LO9i42feF"
                        href="/privacypolicy"
                      >
                        Privacy Policy
                      </a>
                      {/*/$*/}
                    </p>
                  </div>
                  <div
                    className="framer-1nvrqt6 refundpolicy-s21 reveal"
                    data-framer-name="Item"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s51">
                      |
                    </p>
                  </div>
                  <div
                    className="framer-1jvvep9 refundpolicy-s21 reveal"
                    data-framer-name="Item"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s51">
                      {/*$*/}
                      <a
                        className="framer-text framer-styles-preset-11r53mh"
                        data-styles-preset="LO9i42feF"
                        href="/marketingtermsandconditions"
                      >
                        Marketing Terms
                      </a>
                      {/*/$*/}
                    </p>
                  </div>
                </div>
                <div className="framer-1cll581">
                  <div
                    className="framer-1bd502t refundpolicy-s21 reveal"
                    data-framer-name="Item"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s51">
                      {/*$*/}
                      <a
                        className="framer-text framer-styles-preset-11r53mh"
                        data-styles-preset="LO9i42feF"
                        href="/termsandconditions"
                      >
                        Terms &amp; Conditions
                      </a>
                      {/*/$*/}
                    </p>
                  </div>
                  <div
                    className="framer-2cgifo refundpolicy-s21 reveal"
                    data-framer-name="Item"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s51">
                      |
                    </p>
                  </div>
                  <div
                    className="framer-1i5t4i6 refundpolicy-s21 reveal"
                    data-framer-name="Item"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text refundpolicy-s51">
                      {/*$*/}
                      <a
                        className="framer-text framer-styles-preset-11r53mh"
                        data-styles-preset="LO9i42feF"
                        href="/refundpolicy"
                        data-framer-page-link-current="true"
                      >
                        Refund Policy
                      </a>
                      {/*/$*/}
                    </p>
                  </div>
                </div>
              </div>
              <div className="framer-1mrb80h">
                {/*$*/}
                <a
                  data-framer-component-type="SVG"
                  as="a"
                  data-framer-name="Frame 33830"
                  href="https://x.com/emoney_network"
                  target="_blank"
                  rel="noopener"
                  parentsize="0"
                  _constraints="[object Object]"
                  rotation="0"
                  shadows=""
                  className="framer-8zhdtw framer-hgpl7q refundpolicy-s44"
                  aria-hidden="true"
                />
                {/*/$*/}
                {/*$*/}
                <a
                  data-framer-component-type="SVG"
                  as="a"
                  data-framer-name="Frame 33830"
                  href="https://t.me/Emoney_io"
                  target="_blank"
                  rel="noopener"
                  parentsize="0"
                  _constraints="[object Object]"
                  rotation="0"
                  shadows=""
                  className="framer-16xdrjk framer-hgpl7q refundpolicy-s52"
                  aria-hidden="true"
                />
                {/*/$*/}
              </div>
            </div>
          </div>
        </div>
        <div id="overlay" />
        {/*/$*/}
      </>
    </div>
  );
}

export default RefundPolicy;
